// extracted by mini-css-extract-plugin
module.exports = {"studentsTasksContainer":"styles_studentsTasksContainer__3jC4n","studentRow":"styles_studentRow__riOUE"};